<template>
  <ContextMenuRoot v-model:open="open">
    <slot></slot>
  </ContextMenuRoot>
</template>

<script setup lang="ts">
import { ContextMenuRoot } from "reka-ui";

import { provide } from "../Menu/context";

provide({
  id: undefined,
  isNested: false,
  isMobile: false,
  triggerElement: undefined,
});

const open = defineModel<boolean>("open", { default: false });
</script>
